import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import sha1 from 'crypto';

import FeedLayout from '../Includes/FeedLayout';
import ProfileChips from '../Includes/ProfileChips';
import api from '../../services/api';
import MenuPerfil from '../Includes/MenuPerfil';
import imgAvatar from '../../assests/avatar.png';
import { useTranslation } from 'react-i18next';

import './styles.css';

export default function Perfil() {
  let tmpToken = "";
  const { t } = useTranslation();
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const [avatar, setAvatar] = useState();
  const [is_reviwer, setIs_reviwer] = useState();
  const [allow_advertising, setAllowAdvertising] = useState();

  const hash = sha1.createHmac('sha256', USER_EMAIL)
    .update(USER_EMAIL)
    .digest('hex');

  const USER_TOKEN_TEMP = hash;

  const configRequest = {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      'USER_TOKEN': USER_TOKEN,
      'USER_EMAIL': USER_EMAIL
    },
  };

  let user = Array;
  const history = useHistory();

  useEffect(() => {
    api.get(`${BASE_URL}/v4/users/me`, {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
      }
    }).then(response => {
      sessionStorage.setItem('phone', response.data.phone);
      sessionStorage.setItem('tags', JSON.stringify(response.data.interested_tags));
      sessionStorage.setItem('plan', JSON.stringify(response.data.plan));
      setIs_reviwer(response.data.user_preference.is_reviwer);
      setAllowAdvertising(response.data.allow_advertising);
      if (response.data.avatar.medium === null) {
        setAvatar(imgAvatar);
        sessionStorage.setItem('avatar', JSON.stringify(response.data.avatar));
      } else {
        setAvatar(response.data.avatar.medium);
        sessionStorage.setItem('avatar', JSON.stringify(response.data.avatar));
      }
    }).catch(response => {
      history.push("/");
    });
  }, [USER_EMAIL, USER_TOKEN, history, is_reviwer]);

  function tokenTemporario() {
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN_TEMP);
    data.append('USER_EMAIL', USER_TOKEN);

    var config = {
      method: 'post',
      url: BASE_URL + '/v2/users/me/temporary_token',
      headers: {
        'USER_TOKEN': USER_TOKEN,
        'USER_EMAIL': USER_EMAIL,
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        tmpToken = response.data.token;
        const urlToken = 'localhost:3000/checkout';
        sessionStorage.setItem('urlToken', urlToken)
      })
      .catch(function (error) {
      });

  }
  tokenTemporario();
 /**  function abreURL() {
    if (sessionStorage.getItem('urlToken')) {
      window.open(sessionStorage.getItem('urlToken'), '_blank');
    } else {
      return false;
    }
  }*/

  function UrlToken() {
    return (
     <>
      
      <Link id="perfilCheckout" className="btn-plano" to="/checkout/plano"><span>{t('pages.profile.buttons.updatePlan')}</span></Link>
      </>);
  }
  


    function CancelPlan(){
      return(
        <Link id="cancel-plan" className="btn-cancel-plan" to="/cancel-plan" ><span>{t('pages.profile.buttons.cancelPlan')}</span></Link>
      );
    }
  

  function verificaCheck(id) {
    let checkbox = document.getElementById(id);
    let check = true;
    if (checkbox.checked) {
      check = true;
    } else {
      check = false;
    }
    var axios = require('axios');
    var data = { "is_reviwer": check };

    axios({ ...configRequest, url: BASE_URL + '/v5/users/me/user_preferences', data })

    setIs_reviwer(check)
  }

  function checkAllowAdvertising() {
    var axios = require('axios');
    var data = { "allow_advertising": !allow_advertising };

    axios({ ...configRequest, url: BASE_URL + '/v5/users/me', data })

    setAllowAdvertising(!allow_advertising)
  }

  return (
    <FeedLayout active="profile">
    <div className="perfil-container">
      <div className="feed-top">{t('pages.includes.header.profile')}</div>
      <ProfileChips active="profile" />
      <section className="body">
        <div className="conteudo">
          <div className="perfil">
            <img className="imgPerfil" src={avatar} alt={t('pages.profile.alt.withoutPicture')} />
            <p className="name">{sessionStorage.getItem('name')}</p>
            <p className="email">{sessionStorage.getItem('email')}</p>
            <p className="name">{sessionStorage.getItem('phone')}</p>
          </div>
          <MenuPerfil />
          <div className="interesses">
            <h2> {t('pages.profile.interests')} </h2>
            {
              (JSON.parse(sessionStorage.getItem('tags') || '[]') || []).map((tags) => (
                <span className="tags" key={tags.id || tags.name}>{tags.name}</span>
              ))
            }
          </div>
          <div></div>
          <div className="plano">
            <h2> {t('pages.profile.myPlan')} </h2>
            <p>{(JSON.parse(sessionStorage.getItem('plan') || '{}') || {}).name}</p>
            <p>{(JSON.parse(sessionStorage.getItem('plan') || '{}') || {}).description}</p>
          </div>
          <div>
          </div>
          <div class="switch__container">
            <input value="on" onClick={() => verificaCheck('switch-shadow')} id="switch-shadow" class="switch switch--shadow" type="checkbox"
              checked={is_reviwer}
            />
            <label for="switch-shadow" /><h4> {t('pages.profile.allowNegotiationsOfOthersUsers')} </h4><br />
            <input value="on" onClick={() => checkAllowAdvertising()} id="switch-allow-advertising" class="switch switch--shadow" type="checkbox"
              checked={allow_advertising}
            />
            <label for="switch-allow-advertising" /><h4> {t('pages.profile.allowNotifications')} </h4>
          </div>
          <div></div>


          <div className="profile-plan-actions">
            <UrlToken />
            <CancelPlan/>
          </div>


        </div>
        <div id="mensagens" className="msg erro">ESTA DIV É PARA MENSAGENS!!!</div>
      </section>
    </div>
    </FeedLayout>
  )

}